import { CtaBookNow } from 'themes/playful/components/CtaBookNow/CtaBookNow';
import { PlayfulTeamList } from 'themes/playful/components/Team/PlayfulTeamList';
import { TextureSection } from 'themes/playful/components/TextureSection/TextureSection';

import { useTeamPage } from 'hooks/page/team/useTeamPage';

export const PlayfulTeam = () => {
  const { professionals, handleBook } = useTeamPage();

  return (
    <>
      <TextureSection title="Team">
        <PlayfulTeamList
          professionals={professionals}
          onProfessionaClick={handleBook}
        />
      </TextureSection>
      <CtaBookNow />
    </>
  );
};
